import Vue from 'vue'
import VueRouter from 'vue-router'
// @会从src目录查找
import Index from '@/views/Index.vue'
import userDeal from '@/views/userDeal.vue'
import appDownload from '@/views/appDownload.vue'
import appAgtDownload from '@/views/appAgtDownload.vue'
import merchantInformation from '@/views/merchantInformation.vue'
import businessLicense from '@/views/businessLicense.vue'
import aliReport from '@/views/aliReport.vue'
import aliReportAuthSuccess from '@/views/aliReportAuthSuccess.vue'
import aliReportMakeUpPic from '@/views/aliReportMakeUpPic.vue'

// Vue.js 官方提供的一些插件 (例如 vue-router) 在检测到 Vue 是可访问的全局变量时会自动调用 Vue.use()。然而在像 CommonJS 这样的模块环境中，你应该始终显式地调用 Vue.use()
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    meta: { title: '邀请服务商' },
    component: Index
  },
  {
    path: '/userDeal',
    name: 'userDeal',
    meta: { title: '用户协议' },
    component: userDeal
  },
  {
    path: '/appDownload',
    name: 'appDownload',
    meta: { title: 'APP商户下载' },
    component: appDownload
  },
  {
    path: '/appAgtDownload',
    name: 'appAgtDownload',
    meta: { title: 'APP展业下载' },
    component: appAgtDownload
  },
  {
    path: '/merchantInformation',
    name: 'merchantInformation',
    meta: { title: '商户资料补全' },
    component: merchantInformation
  },
  {
    path: '/businessLicense',
    name: 'businessLicense',
    meta: { title: '上传营业执照' },
    component: businessLicense
  },
  {
    path: '/aliReport',
    name: 'aliReport',
    meta: { title: '支付宝报备' },
    component: aliReport
  },
  {
    path: '/aliReportAuthSuccess',
    name: 'aliReportAuthSuccess',
    meta: { title: '支付宝报备' },
    component: aliReportAuthSuccess
  },
  {
    path: '/aliReportMakeUpPic',
    name: 'aliReportMakeUpPic',
    meta: { title: '支付宝报备' },
    component: aliReportMakeUpPic
  }
]

const router = new VueRouter({
  // 注意：key名是routes 不是routers!!!
  routes
})

export default router
